import { Fragment } from 'react';

/**
 * Replaces instances of replaceKey with replaceWith in text.
 * @param {object} props
 * @param {string} props.text text to be converted
 * @param {string} props.replaceKey pattern to be replaced
 * @param {React.ReactNode} props.replaceWith ReactNode to replace the replaceKey with
 * @param {string[]} [props.exceptions]
 *   prevents replacement if replaceKey is followed by one of these
 * @returns {string | React.ReactNode[]} original text if not found, else array of ReactNodes
 */
export default function ReplaceTextWithElement({
  text,
  replaceKey,
  replaceWith,
  exceptions,
}) {
  if (!text.includes(replaceKey)) return text;

  return text.split(replaceKey).map((e, i) => {
    if (i === 0) return e;
    return (
      <Fragment key={e}>
        {exceptions?.some((exception) => e.startsWith(exception)) ? replaceKey : replaceWith}
        {e}
      </Fragment>
    );
  });
}

/**
 * Replaces instances of replaceKey with replaceWith in text.
 * @param {object} props
 * @param {string} props.text text to be converted
 * @param {string} props.replaceKeyFirst first pattern to be replaced
 * @param {string} props.replaceKeySecond second pattern to be replaced
 * @param {React.ReactNode} props.replaceWithFirst ReactNode to replace the ReplaceKeyFirst with
 * @param {React.ReactNode} props.replaceWithSecond ReactNode to replace the replaceKeySecond with
 * @param {string[]} [props.exceptions]
 *   prevents replacement if replaceKey is followed by one of these
 * @returns {string | React.ReactNode[]} original text if not found, else array of ReactNodes
 */
export function DoubleReplaceTextWithElement({
  text,
  replaceKeyFirst,
  replaceKeySecond,
  replaceWithFirst,
  replaceWithSecond,
  exceptions,
}) {
  if (!text.includes(replaceKeyFirst)) return text;
  if (!text.includes(replaceKeySecond)) return text;

  return text.replace(replaceKeyFirst, 'xReplace').replace(replaceKeySecond, 'xReplace').split('xReplace').map((e, i) => {
    if (i === 0) return e;
    if (i === 2) {
      return (
        <Fragment key={e}>
          {exceptions?.some((exception) => e.startsWith(exception)) ?
            replaceWithSecond :
            replaceWithSecond}
          {e}
        </Fragment>
      );
    }
    return (
      <Fragment key={e}>
        {exceptions?.some((exception) => e.startsWith(exception)) ?
          replaceKeyFirst :
          replaceWithFirst}
        {e}
      </Fragment>
    );
  });
}

export function ItalicizeInterac({ text }) {
  return <ReplaceTextWithElement text={text} replaceKey="Interac" replaceWith={<i>Interac</i>} />;
}
